export function profileListHoverUtil(triggerSelector, closestParentSelector, targetSelector) {
  document.querySelectorAll(triggerSelector).forEach(trigger => {
    const parentElement = trigger.closest(closestParentSelector);
    const targetElement = parentElement?.querySelector(targetSelector);

    if (!targetElement) return;

    trigger.addEventListener('mouseenter', () => {
      targetElement.classList.add('is-hover');
    });
    trigger.addEventListener('mouseleave', () => {
      targetElement.classList.remove('is-hover');
    });
  });
}